const BASE =
  (typeof process !== "undefined" &&
    process.env.REACT_APP_WCPM_CELEBRATION_AUDIO_BASE) ||
  "https://read21-assets.s3.us-east-1.amazonaws.com/audios/wcpm";

const join = (file) => `${String(BASE).replace(/\/$/, "")}/${file}`;

export const WCPM_CELEBRATION_AUDIO = {
  wasGreat: join("WasGreat.wav"),
  personalBest: join("PersonalBest.wav"),
  leveledUp: join("LeveledUp.wav"),
  leveledUpTo8: join("LeveledUpTo8.wav"),
};
